<!--
 * @Description:市场营销-线索接收设置
 * @Author: cxh
 * @Date: 2023-06-09 15:19:34
 * @LastEditTime: 2023-07-06 15:23:41
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        rowKey="clueReceiveRecordId"
        :columns="columns"
        serial
        @fetch="fetch"
        ref="tableRef"
        tableId="DcCosFbuClueReceive"
        v-model:search="searchFrom"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="员工工号">
              <a-input v-model:value="searchFrom.employeeNo" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="员工名称">
              <a-input v-model:value="searchFrom.userName" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="线索接收区域">
              <CustomerAreaCascader
                appId="cos_fbu"
                type="search"
                deptInfoId="815717"
                :multiple="false"
                v-model:ids="searchFrom.areaList"
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button @click="handleAdd" type="primary" v-permission="'fbu_marketing_clueReceive_add_btn'">
            新增
          </a-button>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'action'">
            <a-button type="link" @click="handleEdit(record)" v-permission="'fbu_marketing_clueReceive_allocation_btn'">
              分配区域
            </a-button>
            <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_marketing_clueReceive_delete_btn'">
              删除
            </a-button>
          </template>
          <template v-if="column.dataIndex === 'areaId'">
            <CustomerAreaCascaderText
              appId="cos_fbu"
              :lastLeval="true"
              :multiple="true"
              deptInfoId="815717"
              :value="text"
            />
          </template>
        </template>
      </cos-table>
      <AddEditModal ref="addEditModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import type { ClueReceiveListItem } from '@/typings/api/marketingManage'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { clueReceiveGet, clueReceiveDelete } from '@/api/marketing/marketingManage'
import AddEditModal from './components/addEditModal.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
const addEditModalRef = ref()
const tableRef = ref()
const searchFrom = ref<any>({})
const fetch = (params: object, callBack: (res: any) => void) => {
  clueReceiveGet(params).then((res) => {
    callBack(res)
  })
}
// 新增
const handleAdd = () => {
  addEditModalRef.value.toggle()
}
// 编辑
const handleEdit = (record: ClueReceiveListItem) => {
  addEditModalRef.value.toggle(record)
}
const deleteRow = (record: ClueReceiveListItem) => {
  Modal.delete({
    onOk() {
      clueReceiveDelete({ id: record.id }).then(() => {
        message.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  {
    title: '员工名称',
    dataIndex: 'userName',
    fixed: 'left'
  },
  {
    title: '员工工号',
    dataIndex: 'employeeNo'
  },
  {
    title: '上级名称',
    dataIndex: 'managerName'
  },
  {
    title: '部门',
    dataIndex: 'deptName',
    width: 190
  },
  {
    title: '线索接收区域',
    dataIndex: 'areaId',
    width: 350
  },
  {
    title: '操作人',
    dataIndex: 'operatorName'
  },
  {
    title: '操作时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 120
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosFbuMarketClueReceive' }
</script>
